<div class="create-account">
  <div class="left">
    <rap-spinner class="loader-view" *ngIf="isLoading" [showSpinner]="false"></rap-spinner>

    <div class="container">
      <img src="assets/images/Isolation_Mode.svg" alt="App Icon"
        style="align-items: start;  width: 98%; margin-bottom: 30px;">
      <h1 class="title">{{ title }}</h1>
      <p class="sub-title">{{ subTitle }}</p>
      <form [formGroup]="createAccountForm" (ngSubmit)="createAccount()" style=" padding-left: 20px;">
        <div class="error-container" *ngIf="error">
          {{ error }}
        </div>

        <div class="form-group">
          <label for="email">Email address</label>
          <div class="input-container">
            <input type="email" class="search-input" [class.submitted]="submitted"
              [ngClass]="{'is-invalid': submitted && hasEmailError()}" formControlName="email"
              placeholder="Enter an email address" />
            <div class="auth-icons">
              <i class="bi bi-x-circle-fill" [class.icon-hidden]="!(submitted && hasEmailError())"
                style="margin-left: 10px;" (click)="clearInput('email')"></i>
              <i class="bi bi-envelope-fill" style="margin-left: 10px;"></i>
              <i class="bi bi-check-circle-fill" [class.icon-hidden]="!(submitted && !hasEmailError())"
                style="margin-left: 10px; color: green;"></i>
            </div>
          </div>
          <div *ngIf="submitted && f['email'].errors" class="rap-error-text">
            <span *ngIf="f['email'].errors?.['required']">Email is required</span>
            <!-- 'pattern' is the EMAIL_TLD_PATTERN failure; without it a no-TLD
                 address renders an empty error block. -->
            <span *ngIf="f['email'].errors?.['email'] || f['email'].errors?.['pattern']">Enter valid email</span>
          </div>
        </div>

        <div class="form-group">
          <label for="password">Temp Password</label>
          <app-password-input [submitted]="submitted" [formControl]="f['tempPassword']"
            [placeHolder]="'Enter password sent to your email'"></app-password-input>
        </div>

        <div class="form-group">
          <label for="password">Password</label>
          <app-password-input [submitted]="submitted" [formControl]="f['password']"
            [showRequirements]="true" [placeHolder]="'Enter a password'"></app-password-input>
        </div>

        <div class="form-group">
          <label for="password">Re-enter your password</label>
          <app-password-input [submitted]="submitted" [formControl]="f['confirmPassword']"
            [placeHolder]="'Enter a password'"></app-password-input>
        </div>



        <div class="form-group">
          <label for="password">Username</label>
          <div class="input-container">
            <input type="text" class="search-input" [class.submitted]="submitted"
              [ngClass]="{'is-invalid': submitted && f['userName'].invalid}" formControlName="userName"
              placeholder="Enter a username" />
          </div>
          <div *ngIf="submitted && f['userName'].errors" class="rap-error-text">
            <span *ngIf="f['userName'].errors?.['required']">Username is required</span>
          </div>
        </div>

        <div class="form-group">
          <label for="email">Date of Birth</label>
          <div class="input-container">
            <input class="search-input" [class.submitted]="submitted"
              [ngClass]="{'is-invalid': submitted && f['dateOfBirth'].invalid}" type="date"
              placeholder="Enter date of birth" name="dob" formControlName="dateOfBirth" style="padding: 4px 0px;" />
          </div>
          <div *ngIf="submitted && f['dateOfBirth'].errors" class="rap-error-text">
            <span *ngIf="f['dateOfBirth'].errors?.['required']">Date of birth is required</span>
            <span *ngIf="f['dateOfBirth'].errors.underage">You must be at least 18 years old to register.</span>
          </div>
        </div>

        <rap-rect-button-loader [isLoading]="isLoading" [disabled]="false" buttonClass="btn btn-dark btn-signin"
          style="padding-top: 10px;" type="submit" (clickEvent)="createAccount()">
          Create an account
        </rap-rect-button-loader>
        <rap-link-divider></rap-link-divider>

        <rap-rect-button-loader [isLoading]="false" [disabled]="false" buttonClass="btn btn-light btn-create"
          type="submit" (clickEvent)="navigateToSignin()">
          Sign in
        </rap-rect-button-loader>
      </form>
      <rap-terms-privacy></rap-terms-privacy>
    </div>
  </div>
  <div class="right"></div>
</div>